::slotted(*) {
	position: relative;
	overflow: hidden;
}

.ripple {
	content: "";
	display: block;
	position: absolute;
	border-radius: 50%;
	transform: scale(0);
	animation: var(--ripple-animation);
	background-color: rgba(255, 255, 255, 0.7);
	width: var(--ripple-diameter);
	height: var(--ripple-diameter);
	top: var(--ripple-top);
	left: var(--ripple-left);
	pointer-events: none;
	opacity: 1;
	transition: transform 600ms linear, opacity 600ms linear;
}

.ripple-active {
	transform: scale(4);
	opacity: 0;
}